import memoize from 'lodash/memoize';
import { detectOldIE } from '@Services/BrowserHelper';
import Entries from '@Services/Entries';

import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import store from '@Store';
import { getCombinedRouteParams } from '@AppRoutes/AppRoutesSelectors';
import { generateResultsPath } from '@AppRoutes/utils';
import { PAGE_RANGE_MIN, PAGE_RANGE_MAX, GO_TO_PAGE_MIN_PAGES } from './ResultsPaginationConstants';
import history from '../../AppRoutes/history';
/**
 *  For PaginationContainer
 * */

function _getTotalPages({ totalItems, itemsPerPage }) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  return Math.max(totalPages, 1);
}

export const getTotalPages = memoize(_getTotalPages, ({ totalItems, itemsPerPage } = {}) => `${totalItems}/${itemsPerPage}`);

export function getVisibleRange({ totalItems, itemsPerPage, currentPage }) {
  const totalPages = getTotalPages({
    totalItems,
    itemsPerPage,
  });

  if (currentPage <= PAGE_RANGE_MIN + 1 || totalPages - currentPage <= PAGE_RANGE_MIN) {
    return PAGE_RANGE_MAX;
  }
  return PAGE_RANGE_MIN;
}

export function shouldDisplayGoToPage({ totalItems, itemsPerPage }) {
  const totalPages = getTotalPages({
    totalItems,
    itemsPerPage,
  });
  return totalPages > GO_TO_PAGE_MIN_PAGES;
}

export function selectPage(pageNumber) {
  const params = getCombinedRouteParams(store.getState());
  // eslint-disable-next-line no-param-reassign
  pageNumber = String(pageNumber);
  Entries.params.pageNumber = pageNumber;
  params.pageNumber = pageNumber;
  const pathName = generateResultsPath(params);

  history.push({
    pathname: pathName,
    state: params,
  });
}

/**
 *  For ResultsPerPage
 * */

export function getResultsPerPageValues(profileInfo, resultsPerPageIELimit) {
  const isIE = resultsPerPageIELimit && detectOldIE();
  let options = getValueByNs(profileInfo, 'RESULT_PER_PAGE.preferences.RX2_PAGE_SIZE.values', []);

  options.forEach((option) => {
    if (option.value) {
      // eslint-disable-next-line no-param-reassign
      option.value = parseInt(option.value, 10);
    }
  });

  if (isIE) {
    // limit functionality for IE
    options = options.filter((option) => option.value <= 30);
  }

  return options;
}
